type Environment = 'development' | 'dev' | 'uat' | 'prd'

const currentEnvironment = process.env.VUE_APP_ENVIRONMENT as Environment || 'development'

export const isLocalEnvironment = currentEnvironment === 'development'
export const isDevelopmentEnvironment = currentEnvironment === 'development' || currentEnvironment === 'dev'
export const isStagingEnvironment = currentEnvironment === 'uat'
export const isProductionEnvironment = currentEnvironment === 'prd'
